import { ApiError, apiErrorReason } from '@/lib/api';

import type { ResponsibilityRole } from './types';
import { errorAdvice } from '@/lib/error-advice';

// Textos de los responsables por documento. Cero enums crudos (UX-COPY-01); cada error
// dice qué pasó y qué hacer (UX-ERR-01).

/** Etapa del flujo que atiende cada rol. */
export const ROLE_STAGE: Record<ResponsibilityRole, string> = {
  elaborador: 'elaboración',
  revisor: 'revisión',
  aprobador: 'aprobación',
  capacitador: 'capacitación',
};

export function assignedToast(name: string, role: ResponsibilityRole, code: string): string {
  return `${name} quedó a cargo de la ${ROLE_STAGE[role]} de ${code}`;
}

const REJECTIONS: Record<string, string> = {
  responsibility_exists: 'Ya es responsable en ese rol. Elige a otra persona o puesto.',
  person_not_member:
    'Esa persona no está activa en esta empresa. Elige a otra o revisa su acceso en Usuarios.',
  position_not_found: 'Ese puesto ya no existe en el LMS. Busca de nuevo.',
  person_is_external:
    'Un proveedor externo no puede ser responsable. Elige a alguien de la organización.',
  position_not_in_company:
    'Ese puesto no pertenece a esta empresa en el LMS. Elige un puesto de la empresa.',
  person_cannot_read_type:
    'Esa persona no puede consultar documentos de este tipo. Elige a otra o pide a Calidad que revise el acceso por tipo.',
  annulled_document: 'El documento está anulado: no admite responsables.',
  obsolete_document: 'El documento está obsoleto: no admite responsables.',
  lms_unavailable:
    'El LMS no responde y no se pudo validar el puesto. Intenta en unos minutos o asigna a una persona.',
};

export function responsibilityError(err: unknown): string {
  const reason = apiErrorReason(err);
  if (reason !== undefined && REJECTIONS[reason] !== undefined) {
    return REJECTIONS[reason];
  }
  if (err instanceof ApiError && err.status === 404) {
    return 'El documento o la asignación ya no existen. Recarga la ficha.';
  }
  if (err instanceof ApiError && err.status === 403) {
    return 'No tienes permiso para cambiar responsables. Pide acceso al Administrador de Calidad.';
  }
  return `No se pudo guardar. ${errorAdvice(err)}`;
}
